import * as e from "react";
import { useState as B, useRef as z, useEffect as V, useMemo as Ne } from "react";
import { u as Le, a as he, b as ze, c as Ve, d as Fe, e as Ze, f as ge, g as He, h as Be, i as je, j as De, k as _e, l as ve, m as Oe, n as We, o as qe, p as $e, q as Ue, r as Ge, s as pe, t as Qe, v as Xe } from "./hooks-CA4A5LBF.mjs";
import { a as I, c as ee } from "./room-Q0GUQkyk.mjs";
import { RoomEvent as Ye, ConnectionQuality as Q, Track as M, RemoteTrackPublication as J, RemoteAudioTrack as Je, ConnectionState as X } from "livekit-client";
import { ae as te, af as Ee, w as Ke, u as et, f as tt, c as nt, ag as at, X as rt, Y as ct, a1 as q, l as j, ah as W, ai as lt, i as D, B as it, aj as we, j as ot, ak as st, m as ut, al as ne, p as ke, am as dt, an as mt, ao as ft, ap as ht, aq as gt, ar as vt, R as pt } from "./contexts-DzwYztG5.mjs";
const cn = /* @__PURE__ */ e.forwardRef(
  function(n, a) {
    const { buttonProps: c } = Le(n);
    return /* @__PURE__ */ e.createElement("button", { ref: a, ...c }, n.children);
  }
), ln = /* @__PURE__ */ e.forwardRef(
  function({ room: n, ...a }, c) {
    const r = he(n);
    return /* @__PURE__ */ e.createElement("div", { ref: c, ...a }, r);
  }
), on = /* @__PURE__ */ e.forwardRef(
  function(n, a) {
    const { mergedProps: c } = ze({ props: n });
    return /* @__PURE__ */ e.createElement("button", { ref: a, ...c }, n.children);
  }
), sn = /* @__PURE__ */ e.forwardRef(
  function(n, a) {
    const { buttonProps: c } = Ve(n);
    return /* @__PURE__ */ e.createElement("button", { ref: a, ...c }, n.children);
  }
), Et = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "currentColor", ...t }, /* @__PURE__ */ e.createElement("path", { d: "M1.354.646a.5.5 0 1 0-.708.708l14 14a.5.5 0 0 0 .708-.708L11 10.293V4.5A1.5 1.5 0 0 0 9.5 3H3.707zM0 4.5a1.5 1.5 0 0 1 .943-1.393l9.532 9.533c-.262.224-.603.36-.975.36h-8A1.5 1.5 0 0 1 0 11.5z" }), /* @__PURE__ */ e.createElement("path", { d: "m15.2 3.6-2.8 2.1a1 1 0 0 0-.4.8v3a1 1 0 0 0 .4.8l2.8 2.1a.5.5 0 0 0 .8-.4V4a.5.5 0 0 0-.8-.4z" })), wt = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "currentColor", ...t }, /* @__PURE__ */ e.createElement("path", { d: "M0 4.5A1.5 1.5 0 0 1 1.5 3h8A1.5 1.5 0 0 1 11 4.5v7A1.5 1.5 0 0 1 9.5 13h-8A1.5 1.5 0 0 1 0 11.5zM15.2 3.6l-2.8 2.1a1 1 0 0 0-.4.8v3a1 1 0 0 0 .4.8l2.8 2.1a.5.5 0 0 0 .8-.4V4a.5.5 0 0 0-.8-.4z" })), un = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ e.createElement(
  "path",
  {
    fill: "#FFF",
    d: "M4.99 3.99a1 1 0 0 0-.697 1.717L10.586 12l-6.293 6.293a1 1 0 1 0 1.414 1.414L12 13.414l6.293 6.293a1 1 0 1 0 1.414-1.414L13.414 12l6.293-6.293a1 1 0 0 0-.727-1.717 1 1 0 0 0-.687.303L12 10.586 5.707 4.293a1 1 0 0 0-.717-.303z"
  }
)), dn = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 18, fill: "none", ...t }, /* @__PURE__ */ e.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M0 2.75A2.75 2.75 0 0 1 2.75 0h10.5A2.75 2.75 0 0 1 16 2.75v13.594a.75.75 0 0 1-1.234.572l-3.691-3.12a1.25 1.25 0 0 0-.807-.296H2.75A2.75 2.75 0 0 1 0 10.75v-8ZM2.75 1.5c-.69 0-1.25.56-1.25 1.25v8c0 .69.56 1.25 1.25 1.25h7.518c.65 0 1.279.23 1.775.65l2.457 2.077V2.75c0-.69-.56-1.25-1.25-1.25H2.75Z",
    clipRule: "evenodd"
  }
), /* @__PURE__ */ e.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3 4.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5Zm0 2a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5Zm0 2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5Z",
    clipRule: "evenodd"
  }
)), oe = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", ...t }, /* @__PURE__ */ e.createElement(
  "path",
  {
    fill: "currentcolor",
    fillRule: "evenodd",
    d: "M5.293 2.293a1 1 0 0 1 1.414 0l4.823 4.823a1.25 1.25 0 0 1 0 1.768l-4.823 4.823a1 1 0 0 1-1.414-1.414L9.586 8 5.293 3.707a1 1 0 0 1 0-1.414z",
    clipRule: "evenodd"
  }
)), kt = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", ...t }, /* @__PURE__ */ e.createElement("g", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5 }, /* @__PURE__ */ e.createElement("path", { d: "M10 1.75h4.25m0 0V6m0-4.25L9 7M6 14.25H1.75m0 0V10m0 4.25L7 9" }))), mn = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", ...t }, /* @__PURE__ */ e.createElement(
  "path",
  {
    fill: "currentcolor",
    fillRule: "evenodd",
    d: "M8.961.894C8.875-.298 7.125-.298 7.04.894c-.066.912-1.246 1.228-1.76.472-.67-.99-2.186-.115-1.664.96.399.824-.465 1.688-1.288 1.289-1.076-.522-1.95.994-.961 1.665.756.513.44 1.693-.472 1.759-1.192.086-1.192 1.836 0 1.922.912.066 1.228 1.246.472 1.76-.99.67-.115 2.186.96 1.664.824-.399 1.688.465 1.289 1.288-.522 1.076.994 1.95 1.665.961.513-.756 1.693-.44 1.759.472.086 1.192 1.836 1.192 1.922 0 .066-.912 1.246-1.228 1.76-.472.67.99 2.186.115 1.664-.96-.399-.824.465-1.688 1.288-1.289 1.076.522 1.95-.994.961-1.665-.756-.513-.44-1.693.472-1.759 1.192-.086 1.192-1.836 0-1.922-.912-.066-1.228-1.246-.472-1.76.99-.67.115-2.186-.96-1.664-.824.399-1.688-.465-1.289-1.288.522-1.076-.994-1.95-1.665-.961-.513.756-1.693.44-1.759-.472ZM8 13A5 5 0 1 0 8 3a5 5 0 0 0 0 10Z",
    clipRule: "evenodd"
  }
)), fn = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", ...t }, /* @__PURE__ */ e.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2 2.75A2.75 2.75 0 0 1 4.75 0h6.5A2.75 2.75 0 0 1 14 2.75v10.5A2.75 2.75 0 0 1 11.25 16h-6.5A2.75 2.75 0 0 1 2 13.25v-.5a.75.75 0 0 1 1.5 0v.5c0 .69.56 1.25 1.25 1.25h6.5c.69 0 1.25-.56 1.25-1.25V2.75c0-.69-.56-1.25-1.25-1.25h-6.5c-.69 0-1.25.56-1.25 1.25v.5a.75.75 0 0 1-1.5 0v-.5Z",
    clipRule: "evenodd"
  }
), /* @__PURE__ */ e.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.78 7.47a.75.75 0 0 1 0 1.06l-2.25 2.25a.75.75 0 1 1-1.06-1.06l.97-.97H1.75a.75.75 0 0 1 0-1.5h4.69l-.97-.97a.75.75 0 0 1 1.06-1.06l2.25 2.25Z",
    clipRule: "evenodd"
  }
)), bt = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", ...t }, /* @__PURE__ */ e.createElement(
  "path",
  {
    fill: "currentcolor",
    fillRule: "evenodd",
    d: "M4 6.104V4a4 4 0 1 1 8 0v2.104c1.154.326 2 1.387 2 2.646v4.5A2.75 2.75 0 0 1 11.25 16h-6.5A2.75 2.75 0 0 1 2 13.25v-4.5c0-1.259.846-2.32 2-2.646ZM5.5 4a2.5 2.5 0 0 1 5 0v2h-5V4Z",
    clipRule: "evenodd"
  }
)), Rt = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "currentColor", ...t }, /* @__PURE__ */ e.createElement("path", { d: "M12.227 11.52a5.477 5.477 0 0 0 1.246-2.97.5.5 0 0 0-.995-.1 4.478 4.478 0 0 1-.962 2.359l-1.07-1.07C10.794 9.247 11 8.647 11 8V3a3 3 0 0 0-6 0v1.293L1.354.646a.5.5 0 1 0-.708.708l14 14a.5.5 0 0 0 .708-.708zM8 12.5c.683 0 1.33-.152 1.911-.425l.743.743c-.649.359-1.378.59-2.154.66V15h2a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1h2v-1.522a5.502 5.502 0 0 1-4.973-4.929.5.5 0 0 1 .995-.098A4.5 4.5 0 0 0 8 12.5z" }), /* @__PURE__ */ e.createElement("path", { d: "M8.743 10.907 5 7.164V8a3 3 0 0 0 3.743 2.907z" })), yt = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "currentColor", ...t }, /* @__PURE__ */ e.createElement(
  "path",
  {
    fillRule: "evenodd",
    d: "M2.975 8.002a.5.5 0 0 1 .547.449 4.5 4.5 0 0 0 8.956 0 .5.5 0 1 1 .995.098A5.502 5.502 0 0 1 8.5 13.478V15h2a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1h2v-1.522a5.502 5.502 0 0 1-4.973-4.929.5.5 0 0 1 .448-.547z",
    clipRule: "evenodd"
  }
), /* @__PURE__ */ e.createElement("path", { d: "M5 3a3 3 0 1 1 6 0v5a3 3 0 0 1-6 0z" })), Mt = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "currentcolor", ...t }, /* @__PURE__ */ e.createElement("path", { d: "M0 11.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5zm6-5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5zm6-6a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v15a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5z" }), /* @__PURE__ */ e.createElement("path", { d: "M0 11.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5zm6-5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5zm6-6a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v15a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5z" })), St = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "currentcolor", ...t }, /* @__PURE__ */ e.createElement("path", { d: "M0 11.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5zm6-5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5z" }), /* @__PURE__ */ e.createElement("path", { d: "M0 11.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5zm6-5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5z" }), /* @__PURE__ */ e.createElement("g", { opacity: 0.25 }, /* @__PURE__ */ e.createElement("path", { d: "M12 .5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v15a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5z" }), /* @__PURE__ */ e.createElement("path", { d: "M12 .5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v15a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5z" }))), Ct = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "currentcolor", ...t }, /* @__PURE__ */ e.createElement("path", { d: "M0 11.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5z" }), /* @__PURE__ */ e.createElement("path", { d: "M0 11.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5z" }), /* @__PURE__ */ e.createElement("g", { opacity: 0.25 }, /* @__PURE__ */ e.createElement("path", { d: "M6 6.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5z" }), /* @__PURE__ */ e.createElement("path", { d: "M6 6.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5zm6-6a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v15a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5z" }), /* @__PURE__ */ e.createElement("path", { d: "M12 .5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v15a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5z" }))), It = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "currentColor", ...t }, /* @__PURE__ */ e.createElement("g", { opacity: 0.25 }, /* @__PURE__ */ e.createElement("path", { d: "M0 11.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-4Zm6-5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-9Zm6-6a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v15a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5V.5Z" }), /* @__PURE__ */ e.createElement("path", { d: "M0 11.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-4Zm6-5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-9Zm6-6a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v15a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5V.5Z" }))), be = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 16, fill: "none", ...t }, /* @__PURE__ */ e.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M0 2.75A2.75 2.75 0 0 1 2.75 0h14.5A2.75 2.75 0 0 1 20 2.75v10.5A2.75 2.75 0 0 1 17.25 16H2.75A2.75 2.75 0 0 1 0 13.25V2.75ZM2.75 1.5c-.69 0-1.25.56-1.25 1.25v10.5c0 .69.56 1.25 1.25 1.25h14.5c.69 0 1.25-.56 1.25-1.25V2.75c0-.69-.56-1.25-1.25-1.25H2.75Z",
    clipRule: "evenodd"
  }
), /* @__PURE__ */ e.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.47 4.22a.75.75 0 0 1 1.06 0l2.25 2.25a.75.75 0 0 1-1.06 1.06l-.97-.97v4.69a.75.75 0 0 1-1.5 0V6.56l-.97.97a.75.75 0 0 1-1.06-1.06l2.25-2.25Z",
    clipRule: "evenodd"
  }
)), xt = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 16, fill: "none", ...t }, /* @__PURE__ */ e.createElement("g", { fill: "currentColor" }, /* @__PURE__ */ e.createElement("path", { d: "M7.28 4.22a.75.75 0 0 0-1.06 1.06L8.94 8l-2.72 2.72a.75.75 0 1 0 1.06 1.06L10 9.06l2.72 2.72a.75.75 0 1 0 1.06-1.06L11.06 8l2.72-2.72a.75.75 0 0 0-1.06-1.06L10 6.94z" }), /* @__PURE__ */ e.createElement(
  "path",
  {
    fillRule: "evenodd",
    d: "M2.75 0A2.75 2.75 0 0 0 0 2.75v10.5A2.75 2.75 0 0 0 2.75 16h14.5A2.75 2.75 0 0 0 20 13.25V2.75A2.75 2.75 0 0 0 17.25 0zM1.5 2.75c0-.69.56-1.25 1.25-1.25h14.5c.69 0 1.25.56 1.25 1.25v10.5c0 .69-.56 1.25-1.25 1.25H2.75c-.69 0-1.25-.56-1.25-1.25z",
    clipRule: "evenodd"
  }
))), se = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", ...t }, /* @__PURE__ */ e.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 0a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-1.5 0V.75A.75.75 0 0 1 8 0Z",
    clipRule: "evenodd"
  }
), /* @__PURE__ */ e.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 12a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-1.5 0v-2.5A.75.75 0 0 1 8 12Z",
    clipRule: "evenodd",
    opacity: 0.7
  }
), /* @__PURE__ */ e.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 1.072a.75.75 0 0 1 .274 1.024l-1.25 2.165a.75.75 0 0 1-1.299-.75l1.25-2.165A.75.75 0 0 1 12 1.072Z",
    clipRule: "evenodd"
  }
), /* @__PURE__ */ e.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6 11.464a.75.75 0 0 1 .274 1.025l-1.25 2.165a.75.75 0 0 1-1.299-.75l1.25-2.165A.75.75 0 0 1 6 11.464Z",
    clipRule: "evenodd",
    opacity: 0.6
  }
), /* @__PURE__ */ e.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.928 4a.75.75 0 0 1-.274 1.025l-2.165 1.25a.75.75 0 1 1-.75-1.3l2.165-1.25A.75.75 0 0 1 14.928 4Z",
    clipRule: "evenodd"
  }
), /* @__PURE__ */ e.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.536 10a.75.75 0 0 1-.275 1.024l-2.165 1.25a.75.75 0 0 1-.75-1.298l2.165-1.25A.75.75 0 0 1 4.536 10Z",
    clipRule: "evenodd",
    opacity: 0.5
  }
), /* @__PURE__ */ e.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16 8a.75.75 0 0 1-.75.75h-2.5a.75.75 0 0 1 0-1.5h2.5A.75.75 0 0 1 16 8Z",
    clipRule: "evenodd"
  }
), /* @__PURE__ */ e.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4 8a.75.75 0 0 1-.75.75H.75a.75.75 0 0 1 0-1.5h2.5A.75.75 0 0 1 4 8Z",
    clipRule: "evenodd",
    opacity: 0.4
  }
), /* @__PURE__ */ e.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.928 12a.75.75 0 0 1-1.024.274l-2.165-1.25a.75.75 0 0 1 .75-1.299l2.165 1.25A.75.75 0 0 1 14.928 12Z",
    clipRule: "evenodd",
    opacity: 0.9
  }
), /* @__PURE__ */ e.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.536 6a.75.75 0 0 1-1.025.275l-2.165-1.25a.75.75 0 1 1 .75-1.3l2.165 1.25A.75.75 0 0 1 4.536 6Z",
    clipRule: "evenodd",
    opacity: 0.3
  }
), /* @__PURE__ */ e.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 14.928a.75.75 0 0 1-1.024-.274l-1.25-2.165a.75.75 0 0 1 1.298-.75l1.25 2.165A.75.75 0 0 1 12 14.928Z",
    clipRule: "evenodd",
    opacity: 0.8
  }
), /* @__PURE__ */ e.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6 4.536a.75.75 0 0 1-1.024-.275l-1.25-2.165a.75.75 0 1 1 1.299-.75l1.25 2.165A.75.75 0 0 1 6 4.536Z",
    clipRule: "evenodd",
    opacity: 0.2
  }
)), Pt = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", ...t }, /* @__PURE__ */ e.createElement("g", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5 }, /* @__PURE__ */ e.createElement("path", { d: "M13.25 7H9m0 0V2.75M9 7l5.25-5.25M2.75 9H7m0 0v4.25M7 9l-5.25 5.25" }))), Tt = /* @__PURE__ */ e.forwardRef(
  function({ trackRef: n, ...a }, c) {
    const r = te(), { mergedProps: i, inFocus: o } = Fe({
      trackRef: n ?? r,
      props: a
    });
    return /* @__PURE__ */ e.createElement(Ee.Consumer, null, (l) => l !== void 0 && /* @__PURE__ */ e.createElement("button", { ref: c, ...i }, a.children ? a.children : o ? /* @__PURE__ */ e.createElement(Pt, null) : /* @__PURE__ */ e.createElement(kt, null)));
  }
), hn = /* @__PURE__ */ e.forwardRef(
  function({
    kind: n,
    initialSelection: a,
    onActiveDeviceChange: c,
    onDeviceListChange: r,
    onDeviceSelectError: i,
    exactMatch: o,
    track: l,
    requestPermissions: s,
    onError: u,
    ...d
  }, h) {
    const m = Ke(), E = e.useRef("default"), w = e.useCallback(
      (p) => {
        m && m.emit(Ye.MediaDevicesError, p), u?.(p);
      },
      [m, u]
    ), { devices: g, activeDeviceId: v, setActiveMediaDevice: S, className: C } = Ze({
      kind: n,
      room: m,
      track: l,
      requestPermissions: s,
      onError: w
    });
    e.useEffect(() => {
      a !== void 0 && S(a);
    }, [S]), e.useEffect(() => {
      typeof r == "function" && r(g);
    }, [r, g]), e.useEffect(() => {
      v !== E.current && c?.(v), E.current = v;
    }, [v]);
    const A = async (p) => {
      try {
        await S(p, { exact: o ?? !0 });
      } catch (R) {
        if (R instanceof Error)
          i?.(R);
        else
          throw R;
      }
    }, N = e.useMemo(
      () => I(d, { className: C }, { className: "lk-list" }),
      [C, d]
    ), f = !!g.find((p) => p.label.toLowerCase().startsWith("default"));
    function b(p, R, P) {
      return p === R || !f && P === 0 && R === "default";
    }
    return /* @__PURE__ */ e.createElement("ul", { ref: h, ...N }, g.map((p, R) => /* @__PURE__ */ e.createElement(
      "li",
      {
        key: p.deviceId,
        id: p.deviceId,
        "data-lk-active": b(p.deviceId, v, R),
        "aria-selected": b(p.deviceId, v, R),
        role: "option"
      },
      /* @__PURE__ */ e.createElement("button", { className: "lk-button", onClick: () => A(p.deviceId) }, p.label)
    )));
  }
), gn = /* @__PURE__ */ e.forwardRef(
  function({ label: n = "Allow Audio", ...a }, c) {
    const r = et(a.room), { mergedProps: i } = ge({ room: r, props: a });
    return /* @__PURE__ */ e.createElement("button", { ref: c, ...i }, n);
  }
), vn = /* @__PURE__ */ e.forwardRef(
  function({ label: n, ...a }, c) {
    const r = tt(), { mergedProps: i, canPlayAudio: o } = ge({ room: r, props: a }), { mergedProps: l, canPlayVideo: s } = He({ room: r, props: i }), { style: u, ...d } = l;
    return u.display = o && s ? "none" : "block", /* @__PURE__ */ e.createElement("button", { ref: c, style: u, ...d }, n ?? `Start ${o ? "Video" : "Audio"}`);
  }
);
function Re(t, n) {
  switch (t) {
    case M.Source.Microphone:
      return n ? /* @__PURE__ */ e.createElement(yt, null) : /* @__PURE__ */ e.createElement(Rt, null);
    case M.Source.Camera:
      return n ? /* @__PURE__ */ e.createElement(wt, null) : /* @__PURE__ */ e.createElement(Et, null);
    case M.Source.ScreenShare:
      return n ? /* @__PURE__ */ e.createElement(xt, null) : /* @__PURE__ */ e.createElement(be, null);
    default:
      return;
  }
}
function At(t) {
  switch (t) {
    case Q.Excellent:
      return /* @__PURE__ */ e.createElement(Mt, null);
    case Q.Good:
      return /* @__PURE__ */ e.createElement(St, null);
    case Q.Poor:
      return /* @__PURE__ */ e.createElement(Ct, null);
    default:
      return /* @__PURE__ */ e.createElement(It, null);
  }
}
const pn = /* @__PURE__ */ e.forwardRef(function({ showIcon: n, ...a }, c) {
  const { buttonProps: r, enabled: i } = Be(a), [o, l] = e.useState(!1);
  return e.useEffect(() => {
    l(!0);
  }, []), o && /* @__PURE__ */ e.createElement("button", { ref: c, ...r }, (n ?? !0) && Re(a.source, i), a.children);
}), ye = /* @__PURE__ */ e.forwardRef(function(n, a) {
  const { className: c, quality: r } = je(n), i = e.useMemo(() => ({ ...I(n, { className: c }), "data-lk-quality": r }), [r, n, c]);
  return /* @__PURE__ */ e.createElement("div", { ref: a, ...i }, n.children ?? At(r));
}), K = /* @__PURE__ */ e.forwardRef(
  function({ participant: n, ...a }, c) {
    const r = nt(n), { className: i, infoObserver: o } = e.useMemo(() => at(r), [r]), { identity: l, name: s } = De(o, {
      name: r.name,
      identity: r.identity,
      metadata: r.metadata
    }), u = e.useMemo(() => I(a, { className: i, "data-lk-participant-name": s }), [a, i, s]);
    return /* @__PURE__ */ e.createElement("span", { ref: c, ...u }, s !== "" ? s : l, a.children);
  }
), Me = /* @__PURE__ */ e.forwardRef(
  function({ trackRef: n, show: a = "always", ...c }, r) {
    const { className: i, isMuted: o } = _e(n), l = a === "always" || a === "muted" && o || a === "unmuted" && !o, s = e.useMemo(
      () => I(c, {
        className: i
      }),
      [i, c]
    );
    return l ? /* @__PURE__ */ e.createElement("div", { ref: r, ...s, "data-lk-muted": o }, c.children ?? Re(n.source, !o)) : null;
  }
), Nt = (t) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    width: 320,
    height: 320,
    viewBox: "0 0 320 320",
    preserveAspectRatio: "xMidYMid meet",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...t
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M160 180C204.182 180 240 144.183 240 100C240 55.8172 204.182 20 160 20C115.817 20 79.9997 55.8172 79.9997 100C79.9997 144.183 115.817 180 160 180Z",
      fill: "white",
      fillOpacity: 0.25
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M97.6542 194.614C103.267 191.818 109.841 192.481 115.519 195.141C129.025 201.466 144.1 205 159.999 205C175.899 205 190.973 201.466 204.48 195.141C210.158 192.481 216.732 191.818 222.345 194.614C262.703 214.719 291.985 253.736 298.591 300.062C300.15 310.997 291.045 320 280 320H39.9997C28.954 320 19.8495 310.997 21.4087 300.062C28.014 253.736 57.2966 214.72 97.6542 194.614Z",
      fill: "white",
      fillOpacity: 0.25
    }
  )
);
function Se(t, n = {}) {
  const [a, c] = e.useState(rt(t)), [r, i] = e.useState(a?.isMuted), [o, l] = e.useState(a?.isSubscribed), [s, u] = e.useState(a?.track), [d, h] = e.useState("landscape"), m = e.useRef(), { className: E, trackObserver: w } = e.useMemo(() => ct(t), [
    t.participant.sid ?? t.participant.identity,
    t.source,
    q(t) && t.publication.trackSid
  ]);
  return e.useEffect(() => {
    const g = w.subscribe((v) => {
      j.debug("update track", v), c(v), i(v?.isMuted), l(v?.isSubscribed), u(v?.track);
    });
    return () => g?.unsubscribe();
  }, [w]), e.useEffect(() => (s && (m.current && s.detach(m.current), n.element?.current && !(t.participant.isLocal && s?.kind === "audio") && s.attach(n.element.current)), m.current = n.element?.current, () => {
    m.current && s?.detach(m.current);
  }), [s, n.element]), e.useEffect(() => {
    if (typeof a?.dimensions?.width == "number" && typeof a?.dimensions?.height == "number") {
      const g = a.dimensions.width > a.dimensions.height ? "landscape" : "portrait";
      h(g);
    }
  }, [a]), {
    publication: a,
    isMuted: r,
    isSubscribed: o,
    track: s,
    elementProps: I(n.props, {
      className: E,
      "data-lk-local-participant": t.participant.isLocal,
      "data-lk-source": a?.source,
      ...a?.kind === "video" && { "data-lk-orientation": d }
    })
  };
}
var Y, ue;
function Lt() {
  if (ue) return Y;
  ue = 1;
  var t = "Expected a function", n = NaN, a = "[object Symbol]", c = /^\s+|\s+$/g, r = /^[-+]0x[0-9a-f]+$/i, i = /^0b[01]+$/i, o = /^0o[0-7]+$/i, l = parseInt, s = typeof W == "object" && W && W.Object === Object && W, u = typeof self == "object" && self && self.Object === Object && self, d = s || u || Function("return this")(), h = Object.prototype, m = h.toString, E = Math.max, w = Math.min, g = function() {
    return d.Date.now();
  };
  function v(f, b, p) {
    var R, P, _, L, y, T, F = 0, re = !1, Z = !1, $ = !0;
    if (typeof f != "function")
      throw new TypeError(t);
    b = N(b) || 0, S(p) && (re = !!p.leading, Z = "maxWait" in p, _ = Z ? E(N(p.maxWait) || 0, b) : _, $ = "trailing" in p ? !!p.trailing : $);
    function U(k) {
      var x = R, H = P;
      return R = P = void 0, F = k, L = f.apply(H, x), L;
    }
    function xe(k) {
      return F = k, y = setTimeout(O, b), re ? U(k) : L;
    }
    function Pe(k) {
      var x = k - T, H = k - F, ie = b - x;
      return Z ? w(ie, _ - H) : ie;
    }
    function ce(k) {
      var x = k - T, H = k - F;
      return T === void 0 || x >= b || x < 0 || Z && H >= _;
    }
    function O() {
      var k = g();
      if (ce(k))
        return le(k);
      y = setTimeout(O, Pe(k));
    }
    function le(k) {
      return y = void 0, $ && R ? U(k) : (R = P = void 0, L);
    }
    function Te() {
      y !== void 0 && clearTimeout(y), F = 0, R = T = P = y = void 0;
    }
    function Ae() {
      return y === void 0 ? L : le(g());
    }
    function G() {
      var k = g(), x = ce(k);
      if (R = arguments, P = this, T = k, x) {
        if (y === void 0)
          return xe(T);
        if (Z)
          return y = setTimeout(O, b), U(T);
      }
      return y === void 0 && (y = setTimeout(O, b)), L;
    }
    return G.cancel = Te, G.flush = Ae, G;
  }
  function S(f) {
    var b = typeof f;
    return !!f && (b == "object" || b == "function");
  }
  function C(f) {
    return !!f && typeof f == "object";
  }
  function A(f) {
    return typeof f == "symbol" || C(f) && m.call(f) == a;
  }
  function N(f) {
    if (typeof f == "number")
      return f;
    if (A(f))
      return n;
    if (S(f)) {
      var b = typeof f.valueOf == "function" ? f.valueOf() : f;
      f = S(b) ? b + "" : b;
    }
    if (typeof f != "string")
      return f === 0 ? f : +f;
    f = f.replace(c, "");
    var p = i.test(f);
    return p || o.test(f) ? l(f.slice(2), p ? 2 : 8) : r.test(f) ? n : +f;
  }
  return Y = v, Y;
}
var zt = Lt();
const de = /* @__PURE__ */ lt(zt);
function Vt(t) {
  const n = z(t);
  n.current = t, V(
    () => () => {
      n.current();
    },
    []
  );
}
function Ft(t, n = 500, a) {
  const c = z();
  Vt(() => {
    c.current && c.current.cancel();
  });
  const r = Ne(() => {
    const i = de(t, n, a), o = (...l) => i(...l);
    return o.cancel = () => {
      i.cancel();
    }, o.isPending = () => !!c.current, o.flush = () => i.flush(), o;
  }, [t, n, a]);
  return V(() => {
    c.current = de(t, n, a);
  }, [t, n, a]), r;
}
function Zt(t, n, a) {
  const c = ((u, d) => u === d), r = t instanceof Function ? t() : t, [i, o] = B(r), l = z(r), s = Ft(
    o,
    n,
    a
  );
  return c(l.current, r) || (s(r), l.current = r), [i, s];
}
function Ht({
  threshold: t = 0,
  root: n = null,
  rootMargin: a = "0%",
  freezeOnceVisible: c = !1,
  initialIsIntersecting: r = !1,
  onChange: i
} = {}) {
  var o;
  const [l, s] = B(null), [u, d] = B(() => ({
    isIntersecting: r,
    entry: void 0
  })), h = z();
  h.current = i;
  const m = ((o = u.entry) == null ? void 0 : o.isIntersecting) && c;
  V(() => {
    if (!l || !("IntersectionObserver" in window) || m)
      return;
    const g = new IntersectionObserver(
      (v) => {
        const S = Array.isArray(g.thresholds) ? g.thresholds : [g.thresholds];
        v.forEach((C) => {
          const A = C.isIntersecting && S.some((N) => C.intersectionRatio >= N);
          d({ isIntersecting: A, entry: C }), h.current && h.current(A, C);
        });
      },
      { threshold: t, root: n, rootMargin: a }
    );
    return g.observe(l), () => {
      g.disconnect();
    };
  }, [
    l,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    JSON.stringify(t),
    n,
    a,
    m,
    c
  ]);
  const E = z(null);
  V(() => {
    var g;
    !l && ((g = u.entry) != null && g.target) && !c && !m && E.current !== u.entry.target && (E.current = u.entry.target, d({ isIntersecting: r, entry: void 0 }));
  }, [l, u.entry, c, m, r]);
  const w = [
    s,
    !!u.isIntersecting,
    u.entry
  ];
  return w.ref = w[0], w.isIntersecting = w[1], w.entry = w[2], w;
}
const Bt = /* @__PURE__ */ e.forwardRef(
  function({
    onTrackClick: n,
    onClick: a,
    onSubscriptionStatusChanged: c,
    trackRef: r,
    manageSubscription: i,
    ...o
  }, l) {
    const s = D(r), u = e.useRef(null);
    e.useImperativeHandle(l, () => u.current);
    const d = Ht({ root: u.current }), [h] = Zt(d, 3e3);
    e.useEffect(() => {
      i && s.publication instanceof J && h?.isIntersecting === !1 && d?.isIntersecting === !1 && s.publication.setSubscribed(!1);
    }, [h, s, i]), e.useEffect(() => {
      i && s.publication instanceof J && d?.isIntersecting === !0 && s.publication.setSubscribed(!0);
    }, [d, s, i]);
    const {
      elementProps: m,
      publication: E,
      isSubscribed: w
    } = Se(s, {
      element: u,
      props: o
    });
    e.useEffect(() => {
      c?.(!!w);
    }, [w, c]);
    const g = (v) => {
      a?.(v), n?.({ participant: s?.participant, track: E });
    };
    return /* @__PURE__ */ e.createElement("video", { ref: u, ...m, muted: !0, onClick: g });
  }
), ae = /* @__PURE__ */ e.forwardRef(
  function({ trackRef: n, onSubscriptionStatusChanged: a, volume: c, ...r }, i) {
    const o = D(n), l = e.useRef(null);
    e.useImperativeHandle(i, () => l.current);
    const {
      elementProps: s,
      isSubscribed: u,
      track: d,
      publication: h
    } = Se(o, {
      element: l,
      props: r
    });
    return e.useEffect(() => {
      a?.(!!u);
    }, [u, a]), e.useEffect(() => {
      d === void 0 || c === void 0 || (d instanceof Je ? d.setVolume(c) : j.warn("Volume can only be set on remote audio tracks."));
    }, [c, d]), e.useEffect(() => {
      h === void 0 || r.muted === void 0 || (h instanceof J ? h.setEnabled(!r.muted) : j.warn("Can only call setEnabled on remote track publications."));
    }, [r.muted, h, d]), /* @__PURE__ */ e.createElement("audio", { ref: l, ...s });
  }
);
function jt(t) {
  const n = !!it();
  return t.participant && !n ? /* @__PURE__ */ e.createElement(we.Provider, { value: t.participant }, t.children) : /* @__PURE__ */ e.createElement(e.Fragment, null, t.children);
}
function Dt(t) {
  const n = !!te();
  return t.trackRef && !n ? /* @__PURE__ */ e.createElement(ne.Provider, { value: t.trackRef }, t.children) : /* @__PURE__ */ e.createElement(e.Fragment, null, t.children);
}
const _t = /* @__PURE__ */ e.forwardRef(
  function({
    trackRef: n,
    children: a,
    onParticipantClick: c,
    disableSpeakingIndicator: r,
    ...i
  }, o) {
    const l = D(n), { elementProps: s } = ve({
      htmlProps: i,
      disableSpeakingIndicator: r,
      onParticipantClick: c,
      trackRef: l
    }), u = Oe(l.participant), d = ot(), h = st()?.autoSubscription, m = e.useCallback(
      (E) => {
        l.source && !E && d && d.pin.dispatch && ut(l, d.pin.state) && d.pin.dispatch({ msg: "clear_pin" });
      },
      [l, d]
    );
    return /* @__PURE__ */ e.createElement("div", { ref: o, style: { position: "relative" }, ...s }, /* @__PURE__ */ e.createElement(Dt, { trackRef: l }, /* @__PURE__ */ e.createElement(jt, { participant: l.participant }, a ?? /* @__PURE__ */ e.createElement(e.Fragment, null, q(l) && (l.publication?.kind === "video" || l.source === M.Source.Camera || l.source === M.Source.ScreenShare) ? /* @__PURE__ */ e.createElement(
      Bt,
      {
        trackRef: l,
        onSubscriptionStatusChanged: m,
        manageSubscription: h
      }
    ) : q(l) && /* @__PURE__ */ e.createElement(
      ae,
      {
        trackRef: l,
        onSubscriptionStatusChanged: m
      }
    ), /* @__PURE__ */ e.createElement("div", { className: "lk-participant-placeholder" }, /* @__PURE__ */ e.createElement(Nt, null)), /* @__PURE__ */ e.createElement("div", { className: "lk-participant-metadata" }, /* @__PURE__ */ e.createElement("div", { className: "lk-participant-metadata-item" }, l.source === M.Source.Camera ? /* @__PURE__ */ e.createElement(e.Fragment, null, u && /* @__PURE__ */ e.createElement(bt, { style: { marginRight: "0.25rem" } }), /* @__PURE__ */ e.createElement(
      Me,
      {
        trackRef: {
          participant: l.participant,
          source: M.Source.Microphone
        },
        show: "muted"
      }
    ), /* @__PURE__ */ e.createElement(K, null)) : /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(be, { style: { marginRight: "0.25rem" } }), /* @__PURE__ */ e.createElement(K, null, "'s screen"))), /* @__PURE__ */ e.createElement(ye, { className: "lk-participant-metadata-item" }))), /* @__PURE__ */ e.createElement(Tt, { trackRef: l }))));
  }
);
function En(t) {
  const n = I(t, { className: "lk-focus-layout" });
  return /* @__PURE__ */ e.createElement("div", { ...n }, t.children);
}
function wn({ trackRef: t, ...n }) {
  return /* @__PURE__ */ e.createElement(_t, { trackRef: t, ...n });
}
function Ce({ tracks: t, ...n }) {
  return /* @__PURE__ */ e.createElement(e.Fragment, null, t.map((a) => /* @__PURE__ */ e.createElement(
    ne.Provider,
    {
      value: a,
      key: ke(a)
    },
    ee(n.children)
  )));
}
function Ot({
  totalPageCount: t,
  nextPage: n,
  prevPage: a,
  currentPage: c,
  pagesContainer: r
}) {
  const [i, o] = e.useState(!1);
  return e.useEffect(() => {
    let l;
    return r && (l = dt(r.current, 2e3).subscribe(
      o
    )), () => {
      l && l.unsubscribe();
    };
  }, [r]), /* @__PURE__ */ e.createElement("div", { className: "lk-pagination-control", "data-lk-user-interaction": i }, /* @__PURE__ */ e.createElement("button", { className: "lk-button", onClick: a }, /* @__PURE__ */ e.createElement(oe, null)), /* @__PURE__ */ e.createElement("span", { className: "lk-pagination-count" }, `${c} of ${t}`), /* @__PURE__ */ e.createElement("button", { className: "lk-button", onClick: n }, /* @__PURE__ */ e.createElement(oe, null)));
}
const Wt = /* @__PURE__ */ e.forwardRef(
  function({ totalPageCount: n, currentPage: a }, c) {
    const r = new Array(n).fill("").map((i, o) => o + 1 === a ? /* @__PURE__ */ e.createElement("span", { "data-lk-active": !0, key: o }) : /* @__PURE__ */ e.createElement("span", { key: o }));
    return /* @__PURE__ */ e.createElement("div", { ref: c, className: "lk-pagination-indicator" }, r);
  }
);
function kn({ tracks: t, ...n }) {
  const a = e.createRef(), c = e.useMemo(
    () => I(n, { className: "lk-grid-layout" }),
    [n]
  ), { layout: r } = We(a, t.length), i = qe(r.maxTiles, t);
  return $e(a, {
    onLeftSwipe: i.nextPage,
    onRightSwipe: i.prevPage
  }), /* @__PURE__ */ e.createElement("div", { ref: a, "data-lk-pagination": i.totalPageCount > 1, ...c }, /* @__PURE__ */ e.createElement(Ce, { tracks: i.tracks }, n.children), t.length > r.maxTiles && /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(
    Wt,
    {
      totalPageCount: i.totalPageCount,
      currentPage: i.currentPage
    }
  ), /* @__PURE__ */ e.createElement(Ot, { pagesContainer: a, ...i })));
}
const qt = 130, $t = 140, me = 1, Ie = 16 / 10, Ut = (1 - Ie) * -1;
function bn({ tracks: t, orientation: n, ...a }) {
  const c = e.useRef(null), [r, i] = e.useState(0), { width: o, height: l } = Ue(c), s = n || (l >= o ? "vertical" : "horizontal"), u = s === "vertical" ? Math.max(o * Ut, qt) : Math.max(l * Ie, $t), d = mt(), h = Math.max(s === "vertical" ? (l - d) / u : (o - d) / u, me);
  let m = Math.round(h);
  Math.abs(h - r) < 0.5 ? m = Math.round(r) : r !== h && i(h);
  const E = Ge(t, m);
  return e.useLayoutEffect(() => {
    c.current && (c.current.dataset.lkOrientation = s, c.current.style.setProperty("--lk-max-visible-tiles", m.toString()));
  }, [m, s]), /* @__PURE__ */ e.createElement("aside", { key: s, className: "lk-carousel", ref: c, ...a }, /* @__PURE__ */ e.createElement(Ce, { tracks: E }, a.children));
}
function Rn({
  value: t,
  onPinChange: n,
  onWidgetChange: a,
  children: c
}) {
  const r = ft(t);
  return e.useEffect(() => {
    j.debug("PinState Updated", { state: r.pin.state }), n && r.pin.state && n(r.pin.state);
  }, [r.pin.state, n]), e.useEffect(() => {
    j.debug("Widget Updated", { widgetState: r.widget.state }), a && r.widget.state && a(r.widget.state);
  }, [a, r.widget.state]), /* @__PURE__ */ e.createElement(Ee.Provider, { value: r }, c);
}
const yn = /* @__PURE__ */ e.forwardRef(
  function({ trackRef: n, ...a }, c) {
    const d = D(n), h = pe(d, { bands: 7, loPass: 300 });
    return /* @__PURE__ */ e.createElement(
      "svg",
      {
        ref: c,
        width: "100%",
        height: "100%",
        viewBox: "0 0 200 90",
        ...a,
        className: "lk-audio-visualizer"
      },
      /* @__PURE__ */ e.createElement("rect", { x: "0", y: "0", width: "100%", height: "100%" }),
      /* @__PURE__ */ e.createElement(
        "g",
        {
          style: {
            transform: `translate(${130 / 2}px, 0)`
          }
        },
        h.map((m, E) => /* @__PURE__ */ e.createElement(
          "rect",
          {
            key: E,
            x: E * 10,
            y: 90 / 2 - m * 50 / 2,
            width: 6,
            height: m * 50
          }
        ))
      )
    );
  }
);
function Mn({ participants: t, ...n }) {
  return /* @__PURE__ */ e.createElement(e.Fragment, null, t.map((a) => /* @__PURE__ */ e.createElement(we.Provider, { value: a, key: a.identity }, ee(n.children))));
}
function Sn({ room: t, volume: n, muted: a }) {
  const c = Qe(
    [M.Source.Microphone, M.Source.ScreenShareAudio, M.Source.Unknown],
    {
      updateOnlyOn: [],
      onlySubscribed: !0,
      room: t
    }
  ).filter((r) => !r.participant.isLocal && r.publication.kind === M.Kind.Audio);
  return /* @__PURE__ */ e.createElement("div", { style: { display: "none" } }, c.map((r) => /* @__PURE__ */ e.createElement(
    ae,
    {
      key: ke(r),
      trackRef: r,
      volume: n,
      muted: a
    }
  )));
}
const Cn = /* @__PURE__ */ e.forwardRef(function({ childrenPosition: n = "before", children: a, ...c }, r) {
  const { name: i } = Xe();
  return /* @__PURE__ */ e.createElement("span", { ref: r, ...c }, n === "before" && a, i, n === "after" && a);
});
function Gt(t) {
  const n = e.useMemo(() => I(t, { className: "lk-toast" }), [t]);
  return /* @__PURE__ */ e.createElement("div", { ...n }, t.children);
}
const Qt = (t) => {
  const n = [];
  for (let a = 0; a < t; a++)
    n.push([a, t - 1 - a]);
  return n;
}, fe = (t) => [[Math.floor(t / 2)], [-1]], Xt = (t, n, a) => {
  const [c, r] = B(0), [i, o] = B([[]]);
  V(() => {
    if (t === "thinking")
      o(fe(n));
    else if (t === "connecting" || t === "initializing") {
      const s = [...Qt(n)];
      o(s);
    } else o(t === "listening" ? fe(n) : t === void 0 || t === "speaking" ? [new Array(n).fill(0).map((s, u) => u)] : [[]]);
    r(0);
  }, [t, n]);
  const l = z(null);
  return V(() => {
    let s = performance.now();
    const u = (d) => {
      d - s >= a && (r((m) => m + 1), s = d), l.current = requestAnimationFrame(u);
    };
    return l.current = requestAnimationFrame(u), () => {
      l.current !== null && cancelAnimationFrame(l.current);
    };
  }, [a, n, t, i.length]), i[c % i.length];
}, Yt = /* @__PURE__ */ new Map([
  ["connecting", 2e3],
  ["initializing", 2e3],
  ["listening", 500],
  ["thinking", 150]
]), Jt = (t, n) => {
  if (t === void 0)
    return 1e3;
  let a = Yt.get(t);
  return a && t === "connecting" && (a /= n), a;
}, Kt = /* @__PURE__ */ e.forwardRef(
  function({ state: n, options: a, barCount: c = 15, trackRef: r, track: i, children: o, ...l }, s) {
    const u = I(l, { className: "lk-audio-bar-visualizer" });
    let d = te();
    (r || i) && (d = r || i);
    const h = pe(d, {
      bands: c,
      loPass: 100,
      hiPass: 200
    }), m = a?.minHeight ?? 20, E = a?.maxHeight ?? 100, w = Xt(
      n,
      c,
      Jt(n, c) ?? 100
    );
    return /* @__PURE__ */ e.createElement("div", { ref: s, ...u, "data-lk-va-state": n }, h.map(
      (g, v) => o ? ee(o, {
        "data-lk-highlighted": w.includes(v),
        "data-lk-bar-index": v,
        className: "lk-audio-bar",
        style: { height: `${Math.min(E, Math.max(m, g * 100 + 5))}%` }
      }) : /* @__PURE__ */ e.createElement(
        "span",
        {
          key: v,
          "data-lk-highlighted": w.includes(v),
          "data-lk-bar-index": v,
          className: `lk-audio-bar ${w.includes(v) && "lk-highlighted"}`,
          style: {
            // TODO transform animations would be more performant, however the border-radius gets distorted when using scale transforms. a 9-slice approach (or 3 in this case) could work
            // transform: `scale(1, ${Math.min(maxHeight, Math.max(minHeight, volume))}`,
            height: `${Math.min(E, Math.max(m, g * 100 + 5))}%`
          }
        }
      )
    ));
  }
), In = /* @__PURE__ */ e.forwardRef(
  function({
    children: n,
    disableSpeakingIndicator: a,
    onParticipantClick: c,
    trackRef: r,
    ...i
  }, o) {
    const l = D(r), { elementProps: s } = ve({
      trackRef: l,
      htmlProps: i,
      disableSpeakingIndicator: a,
      onParticipantClick: c
    });
    return /* @__PURE__ */ e.createElement("div", { ref: o, style: { position: "relative", minHeight: "160px" }, ...s }, /* @__PURE__ */ e.createElement(ne.Provider, { value: l }, n ?? /* @__PURE__ */ e.createElement(e.Fragment, null, q(l) && /* @__PURE__ */ e.createElement(ae, { trackRef: l }), /* @__PURE__ */ e.createElement(Kt, { barCount: 7, options: { minHeight: 8 } }), /* @__PURE__ */ e.createElement("div", { className: "lk-participant-metadata" }, /* @__PURE__ */ e.createElement("div", { className: "lk-participant-metadata-item" }, /* @__PURE__ */ e.createElement(Me, { trackRef: l }), /* @__PURE__ */ e.createElement(K, null)), /* @__PURE__ */ e.createElement(ye, { className: "lk-participant-metadata-item" })))));
  }
);
function xn(t) {
  const [n, a] = e.useState(void 0), c = he(t.room);
  return e.useEffect(() => {
    switch (c) {
      case X.Reconnecting:
        a(
          /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(se, { className: "lk-spinner" }), " Reconnecting")
        );
        break;
      case X.Connecting:
        a(
          /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(se, { className: "lk-spinner" }), " Connecting")
        );
        break;
      case X.Disconnected:
        a(/* @__PURE__ */ e.createElement(e.Fragment, null, "Disconnected"));
        break;
      default:
        a(void 0);
        break;
    }
  }, [c]), n ? /* @__PURE__ */ e.createElement(Gt, { className: "lk-toast-connection-state" }, n) : /* @__PURE__ */ e.createElement(e.Fragment, null);
}
const Pn = /* @__PURE__ */ e.forwardRef(
  function({ entry: n, hideName: a = !1, hideTimestamp: c = !1, messageFormatter: r, ...i }, o) {
    const l = e.useMemo(() => r ? r(n.message) : n.message, [n.message, r]), s = !!n.editTimestamp, u = new Date(n.timestamp), d = typeof navigator < "u" ? navigator.language : "en-US", h = n.from?.name ?? n.from?.identity;
    return /* @__PURE__ */ e.createElement(
      "li",
      {
        ref: o,
        className: "lk-chat-entry",
        title: u.toLocaleTimeString(d, { timeStyle: "full" }),
        "data-lk-message-origin": n.from?.isLocal ? "local" : "remote",
        ...i
      },
      (!c || !a || s) && /* @__PURE__ */ e.createElement("span", { className: "lk-meta-data" }, !a && /* @__PURE__ */ e.createElement("strong", { className: "lk-participant-name" }, h), (!c || s) && /* @__PURE__ */ e.createElement("span", { className: "lk-timestamp" }, s && "edited ", u.toLocaleTimeString(d, { timeStyle: "short" }))),
      /* @__PURE__ */ e.createElement("span", { className: "lk-message-body" }, l),
      /* @__PURE__ */ e.createElement("span", { className: "lk-message-attachements" }, n.attachedFiles?.map(
        (m) => m.type.startsWith("image/") && /* @__PURE__ */ e.createElement(
          "img",
          {
            style: { maxWidth: "300px", maxHeight: "300px" },
            key: m.name,
            src: URL.createObjectURL(m),
            alt: m.name
          }
        )
      ))
    );
  }
);
function Tn(t) {
  return ht(t, gt()).map((n, a) => {
    if (typeof n == "string")
      return n;
    {
      const c = n.content.toString(), r = n.type === "url" ? /^http(s?):\/\//.test(c) ? c : `https://${c}` : `mailto:${c}`;
      return /* @__PURE__ */ e.createElement("a", { className: "lk-chat-link", key: a, href: r, target: "_blank", rel: "noreferrer" }, c);
    }
  });
}
function An(t) {
  return /* @__PURE__ */ e.createElement(vt.Provider, { value: t.session }, /* @__PURE__ */ e.createElement(pt.Provider, { value: t.session.room }, t.children));
}
export {
  Tn as $,
  ae as A,
  Kt as B,
  on as C,
  sn as D,
  Mt as E,
  En as F,
  kn as G,
  St as H,
  Ct as I,
  It as J,
  Cn as K,
  Rn as L,
  hn as M,
  be as N,
  xt as O,
  _t as P,
  An as Q,
  Sn as R,
  un as S,
  pn as T,
  se as U,
  gn as V,
  Gt as W,
  Me as X,
  Dt as Y,
  Pt as Z,
  Bt as _,
  Pn as a,
  Nt as b,
  dn as c,
  mn as d,
  fn as e,
  vn as f,
  bn as g,
  wn as h,
  xn as i,
  Ce as j,
  In as k,
  yn as l,
  Et as m,
  wt as n,
  oe as o,
  cn as p,
  ye as q,
  ln as r,
  Tt as s,
  kt as t,
  bt as u,
  Rt as v,
  yt as w,
  jt as x,
  Mn as y,
  K as z
};
//# sourceMappingURL=components-DqcPwJ_9.mjs.map
